import { render, staticRenderFns } from "./PackingFlux.vue?vue&type=template&id=6dfd3f39&scoped=true&"
import script from "./PackingFlux.vue?vue&type=script&lang=ts&"
export * from "./PackingFlux.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd3f39",
  null
  
)

export default component.exports